export default __webpack_public_path__ + "static/media/logo-govbr.64ba328d.svg";